import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import axios_instance from "../../api/axios_instance";
import { API_URL } from '../../config';
import { Loader2, TrendingUp } from "lucide-react";
import { useLanguage } from '../../i18n/LanguageContext';

const SideProducts = ({ name }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const backendURL = API_URL;
  const { t, dir, getLabel } = useLanguage();

  useEffect(() => {
    const fetchSideProducts = async () => {
      try {
        const extract = (res) => {
          const d = res.data;
          return Array.isArray(d) ? d : (Array.isArray(d?.products) ? d.products : []);
        };
        const res = await axios_instance.get('/api/products?filter=mostSold&limit=5');
        let data = extract(res);
        if (data.length === 0) {
          const fallback = await axios_instance.get('/api/products?limit=5');
          data = extract(fallback);
        }
        setProducts(data.slice(0, 5));
      } catch (err) {
        console.error("SideProducts Fetch Error", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSideProducts();
  }, []);


  if (loading) return (
    <div className="flex justify-center py-10">
      <Loader2 className="animate-spin text-emerald-600" size={22} />
    </div>
  );

  return (
    <div className="w-full" dir={dir}>
      <div className="flex items-center gap-2.5 mb-5 pb-3 border-b border-gray-100">
        <span className="w-7 h-7 rounded-lg bg-emerald-600 flex items-center justify-center shrink-0">
          <TrendingUp size={14} className="text-white" />
        </span>
        <h3 className="font-black text-gray-900 text-sm tracking-tight">{name}</h3>
      </div>

      <div className="space-y-2">
        {products.map((product) => (
          <Link
            key={product._id}
            to={`/products/${product.slug}`}
            className="flex items-center gap-3 group p-2 rounded-xl hover:bg-gray-50 transition-colors"
          >
            <div className="w-14 h-14 flex-shrink-0 border border-gray-100 rounded-xl overflow-hidden bg-white p-1.5 group-hover:border-emerald-200 transition-colors">
              <img
                src={`${backendURL}/${product.images[0]}`}
                alt={getLabel(product.name)}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="flex flex-col flex-1 min-w-0 text-start">
              <h4 className="font-black text-gray-900 text-xs leading-tight group-hover:text-emerald-600 transition-colors line-clamp-2">
                {getLabel(product.name)}
              </h4>
              <span className="text-emerald-600 font-black text-sm mt-1">
                {product.variants[0]?.price.toFixed(3)} د.ت
              </span>
            </div>
          </Link>
        ))}
      </div>

      <Link
        to="/products"
        className="mt-5 block text-center py-3 border border-gray-200 rounded-2xl text-xs font-black text-gray-600 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 transition-all"
      >
        {t('sideProducts.viewAll')}
      </Link>
    </div>
  );
};

export default SideProducts;
